const $ = window.jQuery;

if ( $( '.content-cards .load-more' ).length ) {

	$( '.content-cards .load-more' ).click( function() {
		const cards = $( this ).closest( '.content-cards' );

		// Set inline display:block to already visible cards
		cards.find( '.content-card:visible' ).css( 'display', 'block' );

		// Breakpoints are in content-cards.scss.
		let cardsPerPage = 2;
		const windowWidth = $( window ).width();
		if ( windowWidth > 899 ) {
			cardsPerPage = 3;
		}
		if ( windowWidth > 1199 ) {
			cardsPerPage = 4;
		}

		const firstNewCard = cards.find( '.content-card:hidden' ).eq(0);

		for ( let i = 0; i < cardsPerPage; i++ ) {
			cards.find( '.content-card:hidden' ).eq(0).show();
		}

		window.requestAnimationFrame( function() {
			$( this ).next( '.announcement' ).text( 'More posts have been loaded.' );
			firstNewCard.find( 'img' ).eq(0).focus();
		} );

		$( this ).attr(
			'data-page',
			Number.parseInt( $( this ).attr( 'data-page' ) ) + 1
		);

		if (
			! cards.find( '.content-card:hidden' ).length ||
			4 === Number.parseInt( $( this ).attr( 'data-page' ) )
		) {
			$( this ).hide();
		}
	} );

	//
	// Handle show/hide resize button
	//
	$( window ).resize( handleResize );
	handleResize();
	function handleResize() {
		$( '.content-cards.is-load-more' ).each( function() {
			if ( $( this ).find( '.content-card:hidden' ).length > 0 ) {
				$( this ).find( '.load-more' ).show();
			} else {
				$( this ).find( '.load-more' ).hide();
			}
		} );
	}

}
